var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.buttonClass,attrs:{"title":_vm.item.is_watched ? 'Mark as unwatched' : 'Mark as watched'},on:{"click":function($event){return _vm.toggleState()}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":_vm.item.is_watched ? 'eye-check' : 'eye',"size":"is-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }